import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  FunnelPlotOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import caseStudyHarvestSrc from './images/case-study-harvest.png';
import caseStudyMailerSrc from './images/case-study-mailer.png';
import { ReactComponent as MoneyIcon } from './images/money.svg';
import { ReactComponent as MailIcon } from './images/open-mail.svg';
import React from 'react';
import styles from './CaseStudies.module.css';

type Props = {
  isWhiteLabel?: boolean;
};

export const CaseStudies = ({ isWhiteLabel }: Props) => {
  const iconStylesProps = { fontSize: 18 };

  const data = [
    {
      id: 1,
      title: 'Harvest Hosts',
      img: caseStudyHarvestSrc,
      points: [
        {
          icon: (
            <ArrowDownOutlined
              style={iconStylesProps}
              className={styles.downArrow}
            />
          ),
          count: '28%',
          text: 'decrease in CPA',
        },
        {
          icon: <MoneyIcon />,
          count: '25x',
          text: `ROI on their ${
            isWhiteLabel ? 'cost with us' : 'Customers.ai cost'
          }`,
        },
        {
          icon: <UsergroupAddOutlined style={iconStylesProps} />,
          count: '58K',
          text: 'weekly increase in retargeting audience',
        },
        {
          icon: (
            <ArrowDownOutlined
              style={iconStylesProps}
              className={styles.downArrow}
            />
          ),
          count: '$20',
          text: 'decrease in customer acquisition cost ',
        },
      ],
    },
    {
      id: 2,
      title: 'Mailer Profit Agency',
      img: caseStudyMailerSrc,
      points: [
        {
          icon: (
            <ArrowUpOutlined
              style={iconStylesProps}
              className={styles.upArrow}
            />
          ),
          count: '$1.7M',
          text: `in attributable revenue from ${
            isWhiteLabel ? 'our tool' : 'Customers.ai'
          }`,
        },
        {
          icon: <MoneyIcon />,
          count: '15x',
          text: 'average ROI',
        },
        {
          icon: <MailIcon style={iconStylesProps} />,
          count: '70%+',
          text: 'open rate',
        },
        {
          icon: <FunnelPlotOutlined style={iconStylesProps} />,
          count: '3.5%',
          text: 'average conversion rate',
        },
        {
          icon: (
            <ArrowUpOutlined
              style={iconStylesProps}
              className={styles.upArrow}
            />
          ),
          count: '55%',
          text: 'increase in referral revenue',
        },
      ],
    },
  ];
  return (
    <div className={styles.wrapper}>
      {data.map(data => (
        <div className={styles.container} key={data.id}>
          <div className={styles.title}>{data.title}</div>
          <div className={styles.content}>
            <img src={data.img} className={styles.image} />
            <div className={styles.points}>
              {data.points.map(point => (
                <div className={styles.pointRow} key={point.text}>
                  {point.icon}
                  <div className={styles.column}>
                    <span className={styles.pointCount}>{point.count}</span>
                    <span className={styles.pointText}>{point.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
